import { cva } from 'class-variance-authority'

export const tabs = cva(['py-3 border-t mt-[-1px]'])
